import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ListControlsComponent} from "./list-controls.component";
import {SearchHelpDialogComponent} from "./search-help-dialog.component";
import {FilteredListControlsComponent} from "./filtered-list-controls.component";
import {FilteredListFiltersComponent} from "./filtered-list-filters.component";
import {FormHelpersModule} from "../form-helpers/form-helpers.module";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    FormHelpersModule,
  ],
  declarations: [
    ListControlsComponent,
    SearchHelpDialogComponent,
    FilteredListControlsComponent,
    FilteredListFiltersComponent,
  ],
  entryComponents: [
    SearchHelpDialogComponent,
  ],
  exports: [
    ListControlsComponent,
    FilteredListControlsComponent,
    FilteredListFiltersComponent,
  ],
})

export class PaginationModule {
}
